import React, { useState, useEffect } from "react";
import {
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
  Button,
  Label,
  FormGroup,
  Input,
  FormFeedback,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useDebouncedCallback } from "use-debounce/lib";
import { toast } from "react-hot-toast";
import SyncSelect from "react-select";
import CreatableAsync from "react-select/async-creatable";
import {
  nullChecker,
  isLetter,
  TIPE_PENGUASA,
  isEven,
  uppercaseFirstLetter,
} from "~/utils";
import request from "~/utils/request";

const DetailPenguasa = ({ type, detailPenguasa }) => {
  if (type === TIPE_PENGUASA.PENDUDUK_WARGA) {
    return (
      <>
        <div className="d-flex mb-3">
          <p className="font-weight-bold" style={{ width: "40%" }}>
            Nama
          </p>
          <p style={{ width: "10%" }}>:</p>
          <p style={{ width: "50%" }}>
            {nullChecker(detailPenguasa?.nama?.toUpperCase())}
          </p>
        </div>

        <div className="d-flex mb-3">
          <p className="font-weight-bold" style={{ width: "40%" }}>
            NIK
          </p>
          <p style={{ width: "10%" }}>:</p>
          <p style={{ width: "50%" }}>{nullChecker(detailPenguasa?.nik)}</p>
        </div>

        <div className="d-flex mb-3">
          <p className="font-weight-bold" style={{ width: "40%" }}>
            Jenis Kelamin
          </p>
          <p style={{ width: "10%" }}>:</p>
          <p style={{ width: "50%" }}>
            {nullChecker(uppercaseFirstLetter(detailPenguasa?.jk))}
          </p>
        </div>

        <div className="d-flex mb-3">
          <p className="font-weight-bold" style={{ width: "40%" }}>
            Alamat
          </p>
          <p style={{ width: "10%" }}>:</p>
          <p style={{ width: "50%" }}>
            {nullChecker(uppercaseFirstLetter(detailPenguasa?.alamat_lengkap))}
          </p>
        </div>

        <div className="d-flex mb-3">
          <p className="font-weight-bold" style={{ width: "40%" }}>
            Agama
          </p>
          <p style={{ width: "10%" }}>:</p>
          <p style={{ width: "50%" }}>
            {nullChecker(uppercaseFirstLetter(detailPenguasa?.agama))}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="d-flex mb-3">
        <p className="font-weight-bold" style={{ width: "40%" }}>
          Nama Kepala Keluarga
        </p>
        <p style={{ width: "10%" }}>:</p>
        <p style={{ width: "50%" }}>
          {nullChecker(detailPenguasa?.kepala_keluarga?.nama?.toUpperCase())}
        </p>
      </div>
      <div className="d-flex mb-3">
        <p className="font-weight-bold" style={{ width: "40%" }}>
          Alamat Lengkap
        </p>
        <p style={{ width: "10%" }}>:</p>
        <p style={{ width: "50%" }}>
          {nullChecker(uppercaseFirstLetter(detailPenguasa?.alamat_lengkap))}
        </p>
      </div>
      <div className="d-flex mb-3">
        <p className="font-weight-bold" style={{ width: "40%" }}>
          Status Kesejahteraan
        </p>
        <p style={{ width: "10%" }}>:</p>
        <p style={{ width: "50%" }}>
          {nullChecker(detailPenguasa?.status_kesejahteraan?.toUpperCase())}
        </p>
      </div>
      <div className="d-flex mb-3">
        <p className="font-weight-bold" style={{ width: "40%" }}>
          Penghasilan
        </p>
        <p style={{ width: "10%" }}>:</p>
        <p style={{ width: "50%" }}>
          {nullChecker(detailPenguasa?.penghasilan)}
        </p>
      </div>
      <div className="d-flex mb-3">
        <p className="font-weight-bold" style={{ width: "40%" }}>
          Anggota
        </p>
        <p style={{ width: "10%" }}>:</p>
      </div>
      <Table striped>
        <thead>
          <tr>
            <th>Nama</th>
            <th>NIK</th>
            <th>Status Dalam Keluarga</th>
          </tr>
        </thead>

        <tbody>
          {detailPenguasa?.anggota?.map((anggota) => (
            <tr>
              <td>{nullChecker(anggota?.nama?.toUpperCase())}</td>
              <td>{nullChecker(anggota?.nik)}</td>
              <td>
                {nullChecker(anggota?.status_dalam_keluarga?.toUpperCase())}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

const EditPenguasa = ({ layer, loading: loadingGetPenguasa, detailInfo }) => {
  const { control, register, watch, errors, setValue } = useForm();

  const watchTipePenguasa = watch("tipe", null);
  const watchNamaPenguasa = watch("nama", null);
  const watchNomorIdentitasPenguasa = watch("nomor_identitas", null);

  const [dataKependudukan, setDataKependudukan] = useState([]);
  const [valueSearchDataKependudukan, setValueSearchDataKependudukan] =
    useState("");
  const [loadingReqDataKependudukan, setLoadingReqDataKependudukan] =
    useState(false);

  const [listPenguasa, setListPenguasa] = useState([]);
  const [loadingPut, setLoadingPut] = useState(false);
  const [detailPenguasa, setDetailPenguasa] = useState(null);
  const [dataPickPenguasa, setDataPickPenguasa] = useState(null);
  const [modalDetailKeluarga, setModalDetailKeluarga] = useState(false);
  const [loadingReqDetailPenguasa, setLoadingReqDetailPenguasa] =
    useState(false);

  const debounceSearch = useDebouncedCallback((value) => {
    setValueSearchDataKependudukan(value);
  }, 800);

  const handleAddPenguasa = (values) => {
    const isPenguasa = {
      nama: values?.nama,
      tipe: watchTipePenguasa?.value,
      nomor_identitas:
        values?.nomor_identitas !== "" ? values?.nomor_identitas : "-",
    };

    const newPenguasa = [...listPenguasa, isPenguasa];
    const newListKependudukan = dataKependudukan.filter(
      (elem) => elem.id !== values.id
    );

    const isSamePenguasaWithDefaultData = listPenguasa.some((elem) => {
      if (elem.nomor_identitas && isPenguasa.nomor_identitas !== "-") {
        return elem.nomor_identitas === isPenguasa.nomor_identitas;
      }

      return elem.nama === isPenguasa.nama;
    });

    console.log(isPenguasa, listPenguasa, "HERE");

    if (isSamePenguasaWithDefaultData) {
      toast.error("Penguasa sama tidak bisa ditambahkan !");
    } else {
      setListPenguasa(newPenguasa);
      setDataKependudukan(newListKependudukan);

      setValue("nama", null);
      setValue("nomor_identitas", "");
    }
  };

  const deletePenguasa = (penguasaParam) => {
    const newDataKependudukan = [...dataKependudukan, penguasaParam];

    setListPenguasa(
      listPenguasa.filter(
        (penguasa) => penguasa.nomor_identitas !== penguasaParam.nomor_identitas
      )
    );

    if (
      [TIPE_PENGUASA.KELUARGA_WARGA, TIPE_PENGUASA.PENDUDUK_WARGA].includes(
        watchTipePenguasa.value
      )
    ) {
      setDataKependudukan(newDataKependudukan);
    }
  };

  const handleSubmitPenguasa = () => {
    const payload = { daftar_penguasa: listPenguasa };

    setLoadingPut(true);

    request
      .put(`/v1/sig/${layer.feature.properties.id}/`, payload)
      .then((res) => {
        const newDataPenguasa = res.data.data.daftar_penguasa;
        setListPenguasa(newDataPenguasa);
        toast.success(
          `Data penguasa bidang NBT ${layer.feature.properties.properties.nama} berhasil di perbaharui !`
        );
      })
      .finally(() => setLoadingPut(false));
  };

  const handleRequestDetailPenguasa = (penguasa) => {
    setLoadingReqDetailPenguasa(true);

    let isIdentity = penguasa.nomor_identitas
      ? penguasa.nomor_identitas
      : watchTipePenguasa?.value === TIPE_PENGUASA.PENDUDUK_WARGA
      ? penguasa.nik
      : penguasa.no_kk;

    const isCheckerTipePenguasa = penguasa.tipe ?? watchTipePenguasa?.value;

    let uri = `/v1/keluarga?filter{no_kk.contains}=${isIdentity}&include[]=anggota`;

    if (isCheckerTipePenguasa === TIPE_PENGUASA.PENDUDUK_WARGA) {
      uri = `/v1/penduduk?filter{nik.contains}=${isIdentity}`;
    }

    request
      .get(uri)
      .then((res) => setDetailPenguasa(res.data.data?.[0]))
      .finally(() => {
        setModalDetailKeluarga(true);
        setLoadingReqDetailPenguasa(false);
      });
  };

  const handleReqPenguasaNonWarga = async (value) => {
    const urlReq = `/v1/penguasanonwarga?search=${value}&tipe=${watchTipePenguasa?.value}`;

    try {
      const response = await request.get(urlReq);

      return response?.data?.data?.map((elem) => ({
        label: `${elem.nama} (${elem?.kepenguasaan?.length} bidang)`,
        value: elem.nama,
        nomor_identitas: elem.nomor_identitas,
      }));
    } finally {
    }
  };

  const handleReqDataKependudukan = async (
    tipePenguasa,
    valueSearchDataKependudukan
  ) => {
    const urlReq =
      tipePenguasa === TIPE_PENGUASA.PENDUDUK_WARGA
        ? isLetter(valueSearchDataKependudukan)
          ? `/v1/penduduk?filter{nama.contains}=${valueSearchDataKependudukan}`
          : `/v1/penduduk?filter{nik.contains}=${valueSearchDataKependudukan}`
        : isLetter(valueSearchDataKependudukan)
        ? `/v1/keluarga?filter{anggota.nama.contains}=${valueSearchDataKependudukan}&include[]=anggota`
        : `/v1/keluarga?filter{no_kk.contains}=${valueSearchDataKependudukan}&include[]=anggota`;

    setLoadingReqDataKependudukan(true);

    try {
      const responseData = await request.get(urlReq);

      const kependudukanMapper = responseData?.data?.data?.map((elem) => {
        if (tipePenguasa === TIPE_PENGUASA.PENDUDUK_WARGA) {
          return {
            nama: elem.nama,
            nomor_identitas: elem.nik,
            ...elem,
          };
        }

        return {
          nama: elem.kepala_keluarga.nama ?? "-",
          nomor_identitas: elem.no_kk,
          ...elem,
        };
      });

      setDataKependudukan(kependudukanMapper);
    } finally {
      setLoadingReqDataKependudukan(false);
    }
  };

  useEffect(() => {
    setValue("tipe", { label: "Penduduk Warga", value: "pendudukwarga" });
  }, []);

  useEffect(() => {
    if (detailInfo) {
      setListPenguasa(detailInfo?.daftar_penguasa);
    }
  }, [detailInfo]);

  useEffect(() => {
    if (watchNamaPenguasa?.nomor_identitas) {
      setValue("nomor_identitas", watchNamaPenguasa?.nomor_identitas);
    }
  }, [watchNamaPenguasa]);

  useEffect(() => {
    const isReqKependudukan = [
      TIPE_PENGUASA.PENDUDUK_WARGA,
      TIPE_PENGUASA.KELUARGA_WARGA,
    ];

    if (isReqKependudukan.includes(watchTipePenguasa?.value)) {
      handleReqDataKependudukan(
        watchTipePenguasa?.value,
        valueSearchDataKependudukan
      );
    }
  }, [watchTipePenguasa, valueSearchDataKependudukan]);

  return (
    <React.Fragment>
      <div>
        <FormGroup className="px-2">
          <Label>Tipe Identitas</Label>
          <Controller
            name="tipe"
            control={control}
            rules={{ required: true }}
            render={({ onChange, value }) => (
              <SyncSelect
                value={value}
                options={TIPE_PENGUASA.LISTS}
                onChange={(val) => onChange(val)}
              />
            )}
          />
          {errors?.tipe && (
            <FormFeedback className="d-block">
              Masukkan tipe identitas
            </FormFeedback>
          )}
        </FormGroup>

        {[TIPE_PENGUASA.PENDUDUK_WARGA, TIPE_PENGUASA.KELUARGA_WARGA].includes(
          watchTipePenguasa?.value
        ) && (
          <>
            {" "}
            <FormGroup
              className="px-2"
              style={{
                top: 0,
                width: "100%",
                position: "sticky",
                backgroundColor: "white",
              }}
            >
              <Label>Cari Data</Label>
              <Input
                type="text"
                placeholder={
                  watchTipePenguasa?.value === TIPE_PENGUASA.PENDUDUK_WARGA
                    ? "Ketikkan NIK atau Nama Penduduk"
                    : "Ketikkan Nomor KK atau Nama Anggota"
                }
                onChange={(e) =>
                  debounceSearch.callback(e.target.value?.toLowerCase())
                }
                style={{
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                }}
              />
            </FormGroup>
            <div style={{ height: "130px", overflow: "auto" }}>
              <table className="table table-borderless table-sm">
                {loadingReqDataKependudukan ? (
                  <tr>
                    <td>
                      <Spinner className="d-block mt-3 mx-auto" size="md" />
                    </td>
                  </tr>
                ) : dataKependudukan?.length > 0 ? (
                  dataKependudukan?.map((elem, index) => (
                    <tr
                      className="mb-3"
                      key={elem.id}
                      style={{
                        backgroundColor: isEven(index + 1)
                          ? "#FFFFFF"
                          : "#F5F9FC",
                      }}
                    >
                      <td className="align-middle p-3">
                        <div className="d-flex flex-column">
                          <p className="mb-1">{elem.nomor_identitas}</p>
                          <p>{elem.nama?.toUpperCase()}</p>
                        </div>
                      </td>
                      <td className="pt-3" width="10%">
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() => {
                            setModalDetailKeluarga(true);
                            setDataPickPenguasa(elem);
                            handleRequestDetailPenguasa(elem);
                          }}
                        >
                          <i className="mdi mdi-information" />
                        </button>
                      </td>
                      <td className="pt-3" width="10%">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleAddPenguasa(elem)}
                        >
                          &gt;&gt;
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <div className="text-center mt-4">
                    <i className="mdi mdi-information-outline" /> tidak ada
                    data&nbsp;
                    {watchTipePenguasa?.value === TIPE_PENGUASA.PENDUDUK_WARGA
                      ? "penduduk"
                      : "keluarga"}
                    &nbsp; di desa ini
                  </div>
                )}
              </table>
            </div>
          </>
        )}

        {[
          TIPE_PENGUASA.KELUARGA_NON_WARGA,
          TIPE_PENGUASA.PENDUDUK_NON_WARGA,
        ].includes(watchTipePenguasa?.value) && (
          <div className="mx-2">
            <FormGroup>
              <Label>Nama</Label>
              <Controller
                name="nama"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                render={({ onChange, value }) => (
                  <CreatableAsync
                    cacheOptions
                    defaultOptions
                    value={value}
                    className="kwkwk"
                    placeholder="Pilih atau Buat Nama"
                    onChange={(val) => onChange(val)}
                    loadOptions={handleReqPenguasaNonWarga}
                  />
                )}
              />
            </FormGroup>

            <FormGroup>
              <Label>Nomor Identitas</Label>
              <Input
                type="number"
                name="nomor_identitas"
                innerRef={register}
                autoComplete="off"
                placeholder={
                  watchTipePenguasa?.value === TIPE_PENGUASA.PENDUDUK_NON_WARGA
                    ? "Ketikkan NIK..."
                    : "Ketikkan Nomor KK..."
                }
              />
            </FormGroup>

            <FormGroup>
              <Button
                color="success"
                disabled={!watchNamaPenguasa}
                onClick={() =>
                  handleAddPenguasa({
                    nama: watchNamaPenguasa?.value,
                    nomor_identitas: watchNomorIdentitasPenguasa,
                  })
                }
                block
              >
                Tambah
              </Button>
            </FormGroup>
          </div>
        )}

        {watchTipePenguasa?.value === TIPE_PENGUASA.LAINNYA && (
          <div className="mx-2">
            <FormGroup>
              <Label>Nama</Label>
              <Input
                type="text"
                name="nama"
                autoComplete="off"
                placeholder="contoh: Sekolah"
                innerRef={register({ required: true })}
              />
            </FormGroup>

            <FormGroup>
              <Button
                color="success"
                disabled={!watchNamaPenguasa}
                onClick={() =>
                  handleAddPenguasa({
                    nama: watchNamaPenguasa,
                    nomor_identitas: "-",
                  })
                }
                block
              >
                Tambah
              </Button>
            </FormGroup>
          </div>
        )}

        <div
          className="alert alert-warning text-center"
          style={{ fontSize: ".90rem" }}
        >
          Daftar Penguasa
        </div>

        <div
          className="pb-4"
          style={{ height: "calc(100vh - 550px)", overflow: "auto" }}
        >
          {loadingGetPenguasa ? (
            <Spinner className="d-block mt-3 mx-auto" size="md" />
          ) : (
            listPenguasa?.map((penguasa, i) => (
              <div style={{ backgroundColor: isEven(i) ? "#F5F9FC" : "#FFF" }}>
                <div className="d-flex justify-content-between p-2">
                  <div className="d-flex flex-column ">
                    <p className="font-weight-bold mb-1">
                      {penguasa.nomor_identitas}
                    </p>
                    <p className="mb-1">{penguasa.nama?.toUpperCase()}</p>
                    <p className="mb-1">
                      {
                        TIPE_PENGUASA.LISTS.find(
                          (tipe) => tipe.value === penguasa.tipe
                        ).label
                      }
                    </p>
                  </div>

                  <div>
                    <button
                      className="btn btn-sm btn-info mr-1"
                      disabled={
                        ![
                          TIPE_PENGUASA.KELUARGA_WARGA,
                          TIPE_PENGUASA.PENDUDUK_WARGA,
                        ].includes(penguasa.tipe) || loadingReqDetailPenguasa
                      }
                      onClick={() => {
                        setModalDetailKeluarga(true);
                        setDataPickPenguasa(penguasa);
                        handleRequestDetailPenguasa(penguasa);
                      }}
                    >
                      <i className="mdi mdi-information" />
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deletePenguasa(penguasa)}
                    >
                      <i className="mdi mdi-delete" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <div
        className="simpanPerubahan"
        style={{ position: "absolute", left: 0, right: 0, bottom: -55 }}
      >
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmitPenguasa}
          disabled={loadingPut}
          style={{
            textTransform: "uppercase",
            position: "absolute",
            left: "0",
            right: 0,
            bottom: "0",
            display: "block",
            width: "100%",
            fontSize: "1rem",
            height: "50px",
          }}
        >
          {loadingPut ? "menyimpan data..." : "Simpan"}
        </button>
      </div>

      {/* MODAL DETAIL PENGUASA */}

      <Modal
        centered
        isOpen={modalDetailKeluarga}
        toggle={() => setModalDetailKeluarga(false)}
      >
        <ModalHeader className="text-uppercase bg-info text-white">
          Detail Data dengan nomor identitas{" "}
          {dataPickPenguasa?.nomor_identitas ?? "-"}
        </ModalHeader>

        <ModalBody>
          {!detailPenguasa | loadingGetPenguasa ? (
            <div className="py-5">
              <Spinner className="d-block mx-auto" />
            </div>
          ) : (
            <DetailPenguasa
              detailPenguasa={detailPenguasa}
              type={dataPickPenguasa?.tipe ?? watchTipePenguasa?.value}
            />
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default EditPenguasa;
